import actions, { conditionsActions } from './constants';

export const fetchConditions = () => ({
  type: conditionsActions.FETCH_CONDITIONS,
});

export const fetchConditionsSuccess = (results) => ({
  type: conditionsActions.FETCH_CONDITIONS_SUCCESS,
  results,
});

export const fetchConditionsError = (error) => ({
  type: conditionsActions.FETCH_CONDITIONS_ERROR,
  error,
});

export const fetchDatasetConditions = (category, code) => ({
  type: actions.FETCH_DATASET_CONDITIONS,
  category,
  code,
});

export const fetchDatasetConditionsSuccess = (category, code, results) => ({
  type: actions.FETCH_DATASET_CONDITIONS_SUCCESS,
  category,
  code,
  results,
});

export const fetchDatasetConditionsError = (category, code, error) => ({
  type: actions.FETCH_DATASET_CONDITIONS_ERROR,
  category,
  code,
  error,
});

export const addDatasetCondition = () => ({
  type: actions.ADD_DATASET_CONDITION,
});

export const addDatasetConditionSuccess = (category, code, result, name) => ({
  type: actions.ADD_DATASET_CONDITION_SUCCESS, category, code, result, name,
});

export const addDatasetConditionError = (name, error) => ({
  type: actions.ADD_DATASET_CONDITION_ERROR,
  error,
  name,
});

export const updateDatasetCondition = () => ({
  type: actions.UPDATE_DATASET_CONDITION,
});

export const updateDatasetConditionSuccess = (category, code, result, name) => ({
  type: actions.UPDATE_DATASET_CONDITION_SUCCESS, category, code, result, name,
});

export const updateDatasetConditionError = (name, error) => ({
  type: actions.UPDATE_DATASET_CONDITION_ERROR,
  error,
  name,
});

export const toggleDatasetConditionAdvisoryError = (category, code, datasetConditionId, error, name) => ({
  type: actions.TOGGLE_DATASET_CONDITION_ADVISORY_ERROR, category, code, datasetConditionId, error, name,
});

export const showRemoveDatasetCondition = (category, code, datasetConditionId, name) => ({
  type: actions.SHOW_REMOVE_DATASET_CONDITION,
  category,
  code,
  datasetConditionId,
  name,
});

export const hideRemoveDatasetCondition = () => ({
  type: actions.HIDE_REMOVE_DATASET_CONDITION,
});

export const removeDatasetCondition = (name, items) => ({
  type: actions.REMOVE_DATASET_CONDITION,
  items,
  name,
});

export const removeDatasetConditionSuccess = (name, items) => ({
  type: actions.REMOVE_DATASET_CONDITION_SUCCESS, name, items,
});

export const removeDatasetConditionError = (name, items) => ({
  type: actions.REMOVE_DATASET_CONDITION_ERROR, name, items,
});

export const showAddDatasetCondition = (category, code, name) => ({
  type: actions.SHOW_ADD_DATASET_CONDITION,
  category,
  code,
  name,
});

export const showEditDatasetCondition = (category, code, datasetConditionId, name) => ({
  type: actions.SHOW_EDIT_DATASET_CONDITION,
  category,
  code,
  datasetConditionId,
  name,
});

export const hideDatasetCondition = () => ({
  type: actions.HIDE_DATASET_CONDITION,
});

export const showDatasetConditions = (entity, code, name) => ({
  type: actions.SHOW_DATASET_CONDITIONS,
  entity,
  code,
  name,
});

export const hideDatasetConditions = () => ({
  type: actions.HIDE_DATASET_CONDITIONS,
});

export const showDatasetConditionsSuccess = (results) => ({
  type: actions.SHOW_DATASET_CONDITIONS_SUCCESS,
  results,
});

export const showDatasetConditionsError = (error) => ({
  type: actions.SHOW_DATASET_CONDITIONS_ERROR,
  error,
});

export const updateActiveDatasetConditionProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_DATASET_CONDITION_PROPERTIES,
  properties,
});

export const updateActiveDatasetConditionContext = (properties, field) => ({
  type: actions.UPDATE_ACTIVE_DATASET_CONDITION_CONTEXT,
  properties,
  field,
});

export const updateActiveDatasetConditionConfiguration = (configuration) => ({
  type: actions.UPDATE_ACTIVE_DATASET_CONDITION_CONFIGURATION,
  configuration,
});

export const updateActiveDatasetCondition = (condition) => ({
  type: actions.UPDATE_ACTIVE_DATASET_CONDITION,
  condition,
});

export const toggleDatasetConditionAdvisory = (category, code, datasetConditionId, name) => ({
  type: actions.TOGGLE_DATASET_CONDITION_ADVISORY,
  category,
  code,
  datasetConditionId,
  name,
});

export const downloadDatasetConditionAttachment = (datasetCode, datasetCondition) => ({
  type: actions.DOWNLOAD_DATASET_CONDITION_ATTACHMENT,
  datasetCode,
  datasetCondition,
});

export const downloadDatasetConditionAttachmentError = (datasetCode, datasetCondition, error) => ({
  type: actions.DOWNLOAD_DATASET_CONDITION_ATTACHMENT_ERROR,
  datasetCode,
  datasetCondition,
  error,
});

export const downloadDatasetConditionAttachmentSuccess = (datasetCode, datasetCondition, result) => ({
  type: actions.DOWNLOAD_DATASET_CONDITION_ATTACHMENT_SUCCESS,
  datasetCode,
  datasetCondition,
  result,
});
